import { useEffect } from "react";

const LoginRedirect = () => {
  useEffect(() => {
    window.location.href =
      "https://us-east-15omn7uhsf.auth.us-east-1.amazoncognito.com/login?client_id=31lq7qsuf5epcgbh7kocl350sa&redirect_uri=https://cloudgenomics.net/auth/callback&response_type=code";
  }, []);

  return null; // nothing to render
};

export default LoginRedirect;